"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _vuex = _interopRequireDefault(require("vuex"));

var _getters = _interopRequireDefault(require("./getters"));

var _app = _interopRequireDefault(require("./modules/app"));

var _settings = _interopRequireDefault(require("./modules/settings"));

var _user = _interopRequireDefault(require("./modules/user"));

var _cat = _interopRequireDefault(require("./modules/cat"));

var _cat_tags = _interopRequireDefault(require("./modules/cat_tags"));

var _big_cat_sort = _interopRequireDefault(require("./modules/big_cat_sort"));

var _kitten_sort = _interopRequireDefault(require("./modules/kitten_sort"));

var _big_cat_tags_sort = _interopRequireDefault(require("./modules/big_cat_tags_sort"));

var _feedback = _interopRequireDefault(require("./modules/feedback"));

_vue.default.use(_vuex.default);

var store = new _vuex.default.Store({
  modules: {
    app: _app.default,
    settings: _settings.default,
    user: _user.default,
    cat: _cat.default,
    cat_tags: _cat_tags.default,
    big_cat_sort: _big_cat_sort.default,
    kitten_sort: _kitten_sort.default,
    big_cat_tags_sort: _big_cat_tags_sort.default,
    feedback: _feedback.default
  },
  getters: _getters.default
});
var _default = store;
exports.default = _default;